import React, { useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import localeText from "../../../../../locale";
import { usePayment } from "../../Checkout/context/PaymentContext";
import PayPalCardFieldsOnly from "../../../../../components/PayPalCheckoutCart/PayPalCardFieldsOnly";
import { useCreditCardPayment } from "../../Checkout/hooks/useCreditCardPayment";

const SinglePaymentCreditCard = ({
  currencyProduct,
  currencyFormat,
  combinePayment,
  totalPrice,
}) => {
  const toast = useRef(null);
  const {
    selectedPaymentMethod,
    calculateRemainingPrice,
    setAmountCreditCard,
    amountWallet,
    amountToPayWithExtracredit,
    amountToPayWithCreditCard: contextAmountToPayWithCreditCard,
    amountBankTransfer,
    bankTransferReceipt,
    isPaymentMethodAvailable,
    isTotalCovered,
    isPaymentMethodInUse,
    setAmountExtracredit,
    setAmountWallet,
    setAmountBankTransfer,
    setBankTransferReceipt,
    setLoading: setPaymentLoading,
  } = usePayment();
  const { creditCardData, amountToPayWithCreditCard, loading, clearCreditCardPayment } =
    useCreditCardPayment();

  useEffect(() => {
    if (!combinePayment && selectedPaymentMethod !== "creditCard") {
      if (creditCardData !== null || amountToPayWithCreditCard !== 0) {
        clearCreditCardPayment();
      }
    }
  }, [
    selectedPaymentMethod,
    clearCreditCardPayment,
    creditCardData,
    combinePayment,
    amountToPayWithCreditCard,
  ]);

  useEffect(() => {
    if (!combinePayment && selectedPaymentMethod === "creditCard") {
      setAmountExtracredit(0);
      setAmountWallet(0);
      setAmountBankTransfer(0);
      setBankTransferReceipt(null);
      setAmountCreditCard(totalPrice);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPaymentMethod, combinePayment, totalPrice]);

  const remainingPrice = calculateRemainingPrice();
  const isAvailable = isPaymentMethodAvailable("creditCard");
  const totalCovered = isTotalCovered();
  const isInUse = isPaymentMethodInUse("creditCard");

  if (combinePayment && totalCovered && !isInUse && !loading) {
    return (
      <div className="flex flex-column gap-2">
        <div className="p-3 bg-blue-50 border-round border-blue-200">
          <div className="flex align-items-center gap-2">
            <i className="pi pi-info-circle text-blue-600"></i>
            <span className="text-blue-800 font-medium">{localeText("totalAlreadyCovered")}</span>
          </div>
          <small className="text-blue-700 mt-1 block">
            {localeText("paymentCompleteWithOtherMethodsExplanation")}
          </small>
        </div>
      </div>
    );
  }

  if (combinePayment && !isAvailable && !loading) {
    return (
      <div className="flex flex-column gap-2">
        <div className="p-3 bg-gray-50 border-round border-gray-200">
          <div className="flex align-items-center gap-2">
            <i className="pi pi-ban text-gray-600"></i>
            <span className="text-blue-800 font-medium">{localeText("methodNotAvailable")}</span>
          </div>
          <small className="text-blue-700 mt-1 block">
            {localeText("methodNotAvailableExplanation")}
          </small>
        </div>
      </div>
    );
  }

  const priceToUse = combinePayment
    ? remainingPrice
    : parseFloat((Number(totalPrice) || 0).toFixed(2));

  return (
    <>
      <Toast ref={toast} />
      <PayPalCardFieldsOnly
        userCurrency={currencyProduct}
        price={priceToUse}
        loading={loading}
        setLoading={setPaymentLoading}
        amountWallet={amountWallet || 0}
        priceOriginal={priceToUse}
        toast={toast}
        amountToPayWithExtracredit={amountToPayWithExtracredit || 0}
        amountToPayWithCreditCard={contextAmountToPayWithCreditCard || 0}
        amountBankTransfer={amountBankTransfer || 0}
        bankTransferReceipt={bankTransferReceipt}
        setDisplayPaymentModal={() => {}}
        setIdTransaction={() => {}}
        creditCardData={creditCardData}
        disabled={false}
        contextAmountToPayWithExtracredit={amountToPayWithExtracredit || 0}
        contextAmountBankTransfer={amountBankTransfer || 0}
        onCreditCardApproved={(amount) => {
          setAmountCreditCard(amount);
        }}
      />
    </>
  );
};

export default SinglePaymentCreditCard;
